var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 12,
  viewBox: "0 0 18 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  fillOpacity: .771,
  fillRule: "evenodd",
  d: "M17.34 6a1 1 0 0 0-1.001-1H3.414l2.873-2.88A.999.999 0 0 0 6.289.704a1.005 1.005 0 0 0-1.417.007L.296 5.288a1.01 1.01 0 0 0 0 1.424l4.576 4.576a1 1 0 0 0 1.417.007c.39-.39.387-1.024-.002-1.414L3.414 7H16.34a.998.998 0 0 0 1.001-1z"
})));
export default __webpack_public_path__ + "teg/media/back.c1d82594.svg";
export { SvgComponent as ReactComponent };